// src/pages/PendenzenProjectWrapper.jsx
// Zeigt die Pendenzenliste eines Projekts INNERHALB der Pendenzen-Shell (globale
// Navigation "Pendenzen" + Subtabs bleiben sichtbar), mit "Zurück zur Liste"-Button.
// Wird aus der Projektübersicht / "Meine Pendenzen" heraus geöffnet (US-PEND-005).
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getAllProjects } from "../services/azureProjectsService";
import { SPECIAL_LISTS } from "../services/azurePendenzenService";
import { useAuth } from "../hooks/useAuth";
import { hasRole, ROLES } from "../utils/permissions";
import Pendenzen from "../components/Pendenzen.jsx";

const PendenzenProjectWrapper = () => {
  const { projectCode } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  // Allgemeine Speziallisten (Admin-GL / Team) haben keinen Projekt-Load
  const special = SPECIAL_LISTS.find((s) => s.code === projectCode);

  useEffect(() => {
    if (special) {
      setLoading(false);
      return undefined;
    }
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const projects = await getAllProjects();
        const found = projects.find((p) => p.code === projectCode);
        if (!cancelled) setProject(found || null);
      } catch (err) {
        console.error("Projekt konnte nicht geladen werden:", err);
        if (!cancelled) setProject(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [projectCode, special]);

  const goBack = () => navigate("/main-pendenzen/projekte");

  if (loading) {
    return <div className="loading">Pendenzenliste wird geladen...</div>;
  }

  // Speziallisten
  if (special) {
    if (special.adminOnly && !hasRole(user, ROLES.ADMIN)) {
      return (
        <div className="pendenzen">
          <button type="button" className="pendenzen__back" onClick={goBack}>
            ← Zurück zur Liste
          </button>
          <p className="pendenzen__subtitle">
            Diese Liste ist nur für die Geschäftsleitung sichtbar.
          </p>
        </div>
      );
    }
    return (
      <Pendenzen
        projectUuid={special.uuid}
        projectCode={special.uuid}
        projectTitle={special.title}
        listKind={special.adminOnly ? "admin" : "team"}
        onBack={goBack}
      />
    );
  }

  if (!project) {
    return (
      <div className="pendenzen">
        <button type="button" className="pendenzen__back" onClick={goBack}>
          ← Zurück zur Liste
        </button>
        <p className="pendenzen__subtitle">
          Das Projekt „{projectCode}" wurde nicht gefunden.
        </p>
      </div>
    );
  }

  return (
    <Pendenzen
      projectUuid={project.id}
      projectCode={project.code}
      projectTitle={`${project.code} – ${project.title}`}
      onBack={goBack}
    />
  );
};

export default PendenzenProjectWrapper;
